// Truck Types service
import { 
  collection, 
  doc, 
  getDocs, 
  addDoc, 
  updateDoc, 
  deleteDoc, 
  query, 
  where, 
  serverTimestamp, 
  db 
} from '../../utils/database/firebase-config';
import cache from '../../utils/dataCache';

// Default truck types
const DEFAULT_TRUCK_TYPES = [
  { value: 'dina_refrigerator', name: { en: 'Dina Refrigerator', ar: 'دينا ثلاجة' } },
  { value: 'dina_flatbed', name: { en: 'Dina Flatbed', ar: 'دينا سطحة' } },
  { value: 'dina_mesh', name: { en: 'Dina Mesh', ar: 'دينا شبك' } },
  { value: 'bus', name: { en: 'Bus', ar: 'باص' } },
  { value: 'trailer_stairs', name: { en: 'Trailer Stairs', ar: 'تريلا ستاير' } },
  { value: 'trailer_flatbed', name: { en: 'Trailer Flatbed', ar: 'تريلا سطحة' } }
];

export const truckTypesService = {
  async getTruckTypes(companyId) {
    const key = `truckTypes:${companyId}`;
    const cached = cache.get(key);
    if (cached) return cached;
    try {
      const truckTypesRef = collection(db, 'truckTypes');
      const q = query(truckTypesRef, where('companyId', '==', companyId));
      const snapshot = await getDocs(q);
      const customTypes = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      const allTypes = [
        ...DEFAULT_TRUCK_TYPES.map(type => ({ ...type, isDefault: true })),
        ...customTypes
      ];
      cache.set(key, allTypes);
      return allTypes;
    } catch (error) {
      console.error('Error loading truck types:', error);
      return DEFAULT_TRUCK_TYPES.map(type => ({ ...type, isDefault: true }));
    }
  },

  async addTruckType(truckTypeData) {
    const truckTypesRef = collection(db, 'truckTypes');
    const docRef = await addDoc(truckTypesRef, {
      ...truckTypeData,
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp()
    });
    cache.invalidatePrefix('truckTypes:');
    return docRef.id;
  },

  async updateTruckType(truckTypeId, truckTypeData) {
    const truckTypeRef = doc(db, 'truckTypes', truckTypeId);
    await updateDoc(truckTypeRef, { ...truckTypeData, updatedAt: serverTimestamp() });
    cache.invalidatePrefix('truckTypes:');
    return true;
  },

  async deleteTruckType(truckTypeId) {
    const truckTypeRef = doc(db, 'truckTypes', truckTypeId);
    await deleteDoc(truckTypeRef);
    cache.invalidatePrefix('truckTypes:');
    return true;
  },

  // Save default truck type as custom type (for editing)
  async saveDefaultAsCustom(defaultType, companyId) {
    const truckTypeData = {
      name: defaultType.name,
      value: defaultType.value,
      companyId: companyId,
      wasDefault: true
    };
    
    const truckTypesRef = collection(db, 'truckTypes');
    const docRef = await addDoc(truckTypesRef, { 
      ...truckTypeData, 
      createdAt: serverTimestamp(), 
      updatedAt: serverTimestamp() 
    });
    return docRef.id;
  }
}; 